module.exports = __webpack_public_path__ + "static/img/valores.00043030.png";